import React from 'react'
import { Button } from '@iws/admin-ui/button'
import { Dialog, DialogContent } from '@iws/admin-ui/dialog'

interface ConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  onConfirm: () => void
  confirmText?: string
}

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmText = 'Delete',
}: ConfirmDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[420px]">
      <div className="flex flex-col gap-1 pr-8">
        <h3 className="text-heading-md text-ink">{title}</h3>
        <p className="text-sm text-text-2">{description}</p>
      </div>
      <div className="-mx-6 flex justify-end gap-2 border-t border-border px-6 pt-4">
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={() => { onConfirm(); onOpenChange(false) }}
        >
          {confirmText}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
)
